import { Form, Input, Modal } from "antd";
import { useEffect } from "react";
import { IStationeryCategory } from "../../../models/Hrm";
import { notify } from "../../../utils/toast";
import {
  useCreateStationeryCategory,
  useUpdateStationeryCategory,
} from "../../../query/HrmQuery";

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  editingCategory: IStationeryCategory | null;
}

export const ModalAddStationeryCategory = ({
  isOpen,
  onCancel,
  editingCategory,
}: Props) => {
  const [form] = Form.useForm();

  const createMutation = useCreateStationeryCategory();
  const updateMutation = useUpdateStationeryCategory();

  useEffect(() => {
    if (editingCategory) {
      form.setFieldsValue(editingCategory);
    } else {
      form.resetFields();
    }
  }, [editingCategory, form, isOpen]);

  const handleFormSubmit = async (values: { name: string }) => {
    if (editingCategory) {
      updateMutation.mutate(
        { id: editingCategory.id, ...values },
        {
          onSuccess: () => {
            notify.success("Cập nhật thành công!");
            onCancel();
          },
          onError: () => notify.error("Cập nhật thất bại!"),
        },
      );
    } else {
      createMutation.mutate(
        { name: values.name },
        {
          onSuccess: () => {
            notify.success("Tạo mới thành công!");
            onCancel();
          },
          onError: () => notify.error("Tạo mới thất bại!"),
        },
      );
    }
  };

  return (
    <Modal
      title={editingCategory ? "Chỉnh sửa danh mục" : "Thêm danh mục mới"}
      open={isOpen}
      onCancel={onCancel}
      onOk={() => form.submit()}
      confirmLoading={createMutation.isPending || updateMutation.isPending}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
        <Form.Item
          name="name"
          label="Tên danh mục"
          rules={[{ required: true, message: "Vui lòng nhập tên danh mục" }]}
        >
          <Input placeholder="Nhập tên danh mục..." />
        </Form.Item>
      </Form>
    </Modal>
  );
};
